import React from "react";
import Stage from "./stage";

const Close = require("../../../assets/images/icons/close.svg");

interface MFASetupModalHeaderProps {
  onClose: VoidFunction;
  stage: Stage;
}

export default class MFASetupModalHeader extends React.Component<MFASetupModalHeaderProps> {
  render(): JSX.Element {
    if (this.props.stage === Stage.Code) {
      return (
        <div className="modal__header">
          Enable MFA for your account
          <button
            className="modal__close"
            type="button"
            onClick={this.props.onClose}
          >
            <img src={Close} alt="X symbol" />
          </button>
        </div>
      );
    }

    return <div className="modal__header">MFA enabled!</div>;
  }
}
